import styles from 'styles/views/Events.css';
import onclickoutside from 'react-onclickoutside';
import config from 'config/config_server.json';
import React, { Component, PropTypes } from 'react';
import _ from '../utils/lodash';
import moment from 'moment';
import classnames from 'classnames';
import ToggleButton from 'react-toggle-button';
import Button from 'views/widgets/Button';
import DeleteButton from 'views/widgets/DeleteButton/DeleteButton';
import { checkGeneralCondition } from 'utils/pathUtils';
import cn from 'classnames';

const toggleButtonCommonStyle = {
  flexDirection: 'row'
};

export class Events extends Component {
  static propTypes = {
    events: PropTypes.array.isRequired,
    onEditEvent: PropTypes.func.isRequired,
    onHighlightEvent: PropTypes.func.isRequired,
    onListEvent: PropTypes.func.isRequired,
    onDeleteEvent: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired
  };

  constructor (...args) {
    super(...args);
    this.state = {
      nameFilter: '',
      scopeFilter: false,
      showList: false
    };
  };

  componentWillReceiveProps (nextProps) {
    if (!nextProps.visible) {
      this.setState({...this.state, showList: false});
    }
  };

  render () {
    let { events } = this.props;
    const { scopeFilter, nameFilter, showList } = this.state;
    const localEvents = this.filterEvents();
    if (scopeFilter) {
      events = localEvents;
    }

    if (nameFilter.length) {
      events = this.filterByName(events, nameFilter);
    }

    let chevronDown = `${config.editorUrl}/dropdown_down.svg`;

    return (
      <div className={styles.eventWrapper}>
        <Button
          label='Events'
          disabled={!this.props.visible}
          className={cn(styles.eventButton, {[styles.BtnDisabled]: !this.props.visible})}
          onClick={this.togglePopupDisplay}>
          Events
          <img className={cn(styles.chevronDown, styles.h_o_m)}
            src={chevronDown}
            style={{paddingLeft: 10, width: 20, position: 'relative',
            top: 0, boxSizing: 'border-box'}} alt='Dropdown_arrow_down'/>
        </Button>
        {
          this.props.visible && showList &&
            <div className={styles.events} onClose={this.togglePopupDisplay}>
              <div className={styles.section}>
                <input type='text'
                  autoFocus
                  className={styles.input}
                  onChange={this.setFilterByName}
                  placeholder=' 🔍 Search event'
                  value={this.state.nameFilter}/>
              </div>
              <div className={classnames(styles.section, styles._options)}>
                Only Show Events On Current Page.
                <ToggleButton
                  inactiveLabel={'✕'}
                  colors={{
                    active: {
                      base: '#74cdb0'
                    },
                    inactive: {
                      base: '#aaa'
                    }
                  }}
                  containerStyle={toggleButtonCommonStyle}
                  trackStyle={toggleButtonCommonStyle}
                  value={scopeFilter}
                  onToggle={this.handleToggle}/>
              </div>
              <div className={`${styles.section} ${styles.eventList}`}>
                {
                  events && events.map((event, index) => {
                    let isPending = (event.attrs.status === 'pending' || event.attrs.processState !== 'ready');
                    return (
                      <div
                        key={index}
                        className={styles.row}
                        onMouseEnter={this.setHighlightedEvent(event)}
                        onMouseLeave={this.setHighlightedEvent(null)}>
                        <div
                          className={styles.event}
                          onClick={this.setEditEvent(event)}>
                          <div
                            className={classnames(styles.name, {[styles.pending]: isPending})}>
                            <img className={classnames(styles.eventIcon, {[styles.pendingIcon]: isPending})}
                              src={this.eventIconSrc(event)}
                              alt={event.attrs.name}/>
                            {event.attrs.name + (isPending ? ' (pending)' : '')}
                          </div>
                          <div className={styles.details}>
                          {moment.unix(event.attrs.createdDt/1000).format('MM/DD/YY ')}
                          • {event.elements ? event.elements.length : 0} elements {event.attrs.eventType}
                          </div>
                        </div>
                        <DeleteButton
                          className={styles.delete}
                          onClick={this.props.onDeleteEvent(event)} />
                      </div>
                    );
                  })
                }
                {
                  (!events || events.length === 0) &&
                    <div className={styles.row}>No Events</div>
                }
              </div>
            </div>
            /* </Popup> */
        }
      </div>
    );
  };

  setEditEvent = (event) => () => {
    if (!_.isEmpty(event.attrs.currentContextPath) && location.href !== event.attrs.currentContextPath) {
      try {
        localStorage.setItem('_cachedEvent', event.attrs.id);
      } catch (e) {
        // nothing happen
      }
      location.href = event.attrs.currentContextPath;
      return;
    } else if (event.attrs.pathCondition) {
      const condition = event.attrs.pathCondition;
      const domain = condition[0].value;
      const path = (condition[1] && condition[1].name === 'path') ? condition[1].value : '';
      const url = domain + path;
      const regEx = new RegExp(url, 'gi');
      if (!location.href.match(regEx)) {
        if (event.attrs.eventType !== 'PAGEVIEW') {
          try {
            localStorage.setItem('_cachedEvent', event.attrs.id);
          } catch (e) {
            // nothing happen
          }
        }
        location.href = `http://${url}`;
        return;
      }
    }
    this.setState({...this.state, showList: false});
    this.props.onEditEvent(event);
  }

  setHighlightedEvent = (event) => () => {
    if (event && event.attrs.eventType === 'PAGEVIEW') {
      return;
    }
    this.props.onHighlightEvent(event);
  };

  filterEvents () {
    return this.props.events.filter((event) => {
      if (event.attrs.eventType === 'PAGEVIEW') {
        for (let i = 0; i < event.attrs.content.length; i++) {
          if (!checkGeneralCondition(event.attrs.content[i], true)) return false;
        }
        return true;
      }
      return event.attrs.currentContextPath === window.location.href;
    });
  };

  eventIconSrc = (event) => {
    if (event.attrs.eventType === 'PAGEVIEW') {
      return `${config.editorUrl}/pageview.svg`;
    } else if (event.attrs.eventType === 'CLICK') {
      return `${config.editorUrl}/click.svg`;
    } else if (event.attrs.eventType === 'CUSTOM') {
      return `${config.editorUrl}/custom.svg`;
    }
    return null;
  };

  filterByName (events, filter) {
    return events.filter(item => {
      const regEx = new RegExp(filter, 'gi');
      return item.attrs.name.match(regEx);
    });
  }

  handleToggle = (value) => {
    this.setState({
      scopeFilter: !this.state.scopeFilter
    });
  }

  setFilterByName = (e) => {
    this.setState({...this.state, nameFilter: e.target.value});
  };

  setFilterByScope = (scope) => {
    this.setState({...this.state, scopeFilter: scope});
  };

  togglePopupDisplay = () => {
    this.props.onListEvent(!this.state.showList);
    this.setState({...this.state, showList: !this.state.showList});
  };

  hidePopup = () => {
    if (!this.state.showList) {
      return;
    }

    this.togglePopupDisplay();
  };

  handleClickOutside (e) {
    this.setState({...this.state, showList: false});
  };
}

export default onclickoutside(Events, {
  handleClickOutside: function (instance) {
    return instance.hidePopup;
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/Events.js
 **/